export const CREATE_CSV_LOANS = '@ds-resource/create-csv-loans'

export function createCsvLoans(data) {
  return {
    type: CREATE_CSV_LOANS,
    data,
  }
}
